import { useSeoMeta } from '@unhead/react';
import { Navbar } from '@/components/portfolio/Navbar';
import { Hero } from '@/components/portfolio/Hero';
import { About } from '@/components/portfolio/About';
import { Projects } from '@/components/portfolio/Projects';
import { NostrFeed } from '@/components/portfolio/NostrFeed';
import { Footer } from '@/components/portfolio/Footer';
import { SITE } from '@/lib/site';

const Index = () => {
  useSeoMeta({
    title: `${SITE.name} — Open Source Developer · Bitcoin & Nostr · Nairobi`,
    description: `${SITE.name} is an open source developer based in Nairobi, Kenya, building sovereign tools on Bitcoin and Nostr. See her projects and latest Nostr notes.`,
    ogTitle: `${SITE.name} — Open Source Developer`,
    ogDescription: SITE.tagline,
    twitterCard: 'summary',
  });

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Projects />
        <NostrFeed />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
